import { PServiceCardS, PServiceDetails, PServiceGetFilter } from '@/types/polako-services';
import { apiBaseUrl, dates } from '@/utils/constants';

import { ENTITIES, locationIdOnline } from './api.constant';

export const pServices$filterQuery = (pServiceFilters: PServiceGetFilter): string => {
    const filters: any = {};

    if (pServiceFilters.countryCode && !pServiceFilters.locationCity?.length) {
        // todo filter by country code
        // filters.location = { _or: [{ id: locationIdOnline }, { city: { country: pServiceFilters.countryCode } }] };
    } else if (pServiceFilters.locationCity?.length) {
        filters.location = { _or: [{ id: locationIdOnline }, { city: { _in: pServiceFilters.locationCity } }] };
    }
    if (pServiceFilters.typeLanguage?.length) {
        filters.languages = { language: { code: { _in: pServiceFilters.typeLanguage } } };
    }
    filters.date_from = { _lte: dates.today.format(dates.format) };
    filters.date_to = { _gte: dates.today.format(dates.format) };
    filters.status = { _eq: 'active' };

    return Object.keys(filters) ? encodeURIComponent(JSON.stringify(filters)) : '';
};

const pService$get$part = async <T>(fieldList: string, filterQuery: string): Promise<T[]> => {
    const url = `${apiBaseUrl}${ENTITIES.services}?fields=${fieldList}${filterQuery}&sort=-date_to,-rating`;
    const response = await fetch(url).then((res) => res.json());
    return response?.data ?? [];
};

const fields$card = (
    [
        'animated',
        'id',
        'name',
        'gallery.image_file.id',
        'gallery.image_file.filename_disk',
        'location.id',
        'location.name',
        'price_type',
        'base_currency',
        'price',
        'rating',
        'category',
    ] satisfies Array<
        | keyof PServiceCardS
        | `location.${keyof PServiceCardS}`
        | `gallery.image_file.${keyof PServiceCardS['gallery'][number]['image_file']}`
    >
).join(',');

export async function pService$get$s(filterQuery: string): Promise<PServiceCardS[]> {
    const filterString = filterQuery ? '&filter=' + filterQuery : '';
    const paramsString = `${filterString}`;
    return await pService$get$part<PServiceCardS>(fields$card, paramsString);
}

export const pService$get$count = async (filterQuery: string): Promise<number> => {
    const url = `${apiBaseUrl}${ENTITIES.services}?aggregate[count]=id${filterQuery}`;
    const response = await fetch(url, { next: { revalidate: 600 } }).then((res) => res.json());
    return response?.data?.[0]?.count?.id ?? 0;
};

const fields$details = (
    [
        'animated',
        'id',
        'status',
        'name',
        'price_type',
        'base_currency',
        'price',
        'description',
        'youtube_link',
        'facebook',
        'instagram',
        'telegram',
        'gallery.image_file.id',
        'gallery.image_file.filename_disk',
        'phone',
        'email',
        'rating',
        'documents.document.document',
        //todo fix types
        // @ts-ignore
        'documents.document.document.filename_disk',
        'documents.document.id',
        'documents.document.language_code',
        'documents.document.translations.nom',
        'documents.document.translations.language',
        'location.id',
        'location.name',
        'location.address_link',
        'location.address_text',
        'location.city.name',
        'location.city.country.*',
        'languages.language.title',
        'languages.language.code',
        'languages.language.translations.nom',
        'languages.language.translations.language',
        'category',
        // 'tags.tag.name',
        // 'tags.tag.id',
    ] satisfies Array<
        | keyof PServiceDetails
        | `location.${keyof PServiceDetails['location']}`
        | `location.${keyof PServiceDetails['documents'][number]['document']}`
        | `location.city.${keyof PServiceDetails['location']['city']}`
        | (`location.city.country.${keyof PServiceDetails['location']['city']['country']}` | `location.city.country.*`)
        | `languages.language.${keyof PServiceDetails['languages'][number]['language']}`
        | `languages.language.translations.${keyof PServiceDetails['languages'][number]['language']['translations'][number]}`
        | `tags.tag.${keyof PServiceDetails['tags'][number]['tag']}`
        | `gallery.image_file.${keyof PServiceCardS['gallery'][number]['image_file']}`
        | `documents.document.${keyof PServiceDetails['documents'][number]['document']}`
        | `documents.document.translations.${keyof PServiceDetails['documents'][number]['document']['translations'][number]}`
    >
).join(',');
export const get$pService$details = async (slug: string): Promise<PServiceDetails | null> => {
    const url = `${apiBaseUrl}${ENTITIES.services}/${slug}?fields=${fields$details}`;
    const response = await fetch(url, { cache: 'no-store' }).then((res) => (res.ok ? res.json() : null));
    return response?.data || null;
};

export const getServicesByTorgRs = async () => {
    const url = 'https://torg.rs/api/partner/hedonist';
    try {
        const response = await fetch(url).then((res) => res.json());
        return response.result ?? [];
    } catch {
        return [];
    }
};
